// Formatting helpers ported from the legacy site (public/index.html script).

/** Half-star aware star string, e.g. 3.5 → "★★★½", 0 → "unrated". */
export function stars(rating: number | null | undefined): string {
  if (!rating) return "unrated";
  const full = Math.floor(rating);
  const half = rating % 1 >= 0.5;
  return "★".repeat(full) + (half ? "½" : "");
}

/** "2026-07-04" → "Jul 4, 2026" (falls back to the raw string). */
export function fmtDate(s: string | null | undefined): string {
  if (!s) return "";
  const d = new Date(s + "T00:00:00");
  return isNaN(d.getTime())
    ? s
    : d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

/**
 * AJ's own review text — trusted HTML from his Letterboxd export. Wrap
 * blank-line-separated blocks in <p>, single newlines → <br>. Returns an HTML
 * string intended for dangerouslySetInnerHTML (source is first-party/trusted).
 */
export function fmtReview(html: string | null | undefined): string {
  if (!html) return '<p class="text-text-mute">No written review.</p>';
  return html
    .split(/\r?\n\s*\r?\n/)
    .map((p) => `<p>${p.replace(/\r?\n/g, "<br>")}</p>`)
    .join("");
}

/** Comma-grouped integer, e.g. 21919 → "21,919". */
export function fmtInt(n: number | null | undefined): string {
  if (n == null || isNaN(n)) return "—";
  return Math.round(n).toLocaleString("en-US");
}
